/** Selects the value at the largest reached min-width, regardless of entry order. */
export function resolveBreakpointValue<T>(
  breakpoints: readonly (readonly [number, T])[],
  width: number,
): T | undefined {
  let selectedWidth = -Infinity;
  let resolved: T | undefined;
  for (const [minWidth, value] of breakpoints) {
    if (width >= minWidth && minWidth >= selectedWidth) {
      selectedWidth = minWidth;
      resolved = value;
    }
  }
  return resolved;
}
